module.exports = __webpack_public_path__ + "img/covidCaseSep26toOct2-2022KV.ad3e2293.jpg";